
import './DealerRegister.scss';
import {NavLink as Link} from 'react-router-dom';
// import Table from '../table/Table';
import React from 'react';
import Loading from './../misc/Loading';
import dealers from './../../../../model/dealer';
import makesModel from './../../../../model/makes';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import PublishStatusTableRow from '../table/PublishStatusTableRow.js';
import FilterContainer from '../../../filters';
import {createOptionFilter} from '../../../filters/optionFilter';
import {createTextFilter} from '../../../filters/textFilter';
import {createBooleanFilter} from '../../../filters/booleanFilter';
import {createQueryFilter} from '../../../filters/queryFilter';

class DealerRegisterComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dealers: [],
      filters: [],
      availableFilters: {},
      loading: true
    };

    this.filterCallback = this.filterCallback.bind(this);
  }

  componentDidMount() {
    document.title = 'Admin - Forhandlerregister';
    Promise.all([
      dealers.all(1, ['makes']),
      makesModel.all(),
      dealers.query('fields.groupTags', {
        'fields.groupTags[exists]': true
      })
    ])
      .then(([dealers, makes, groupTags]) => {
        let tags = groupTags.items.reduce((res, tag) => {
          res.push(...tag.fields.groupTags['nb-NO']);

          return res;
        }, []);

        // Keep unique, and sort
        tags = [...new Set(tags)].sort();

        this.setState({
          dealers: dealers,
          availableFilters: this.createFilters(makes, tags),
          loading: false
        });
      });
  }

  createFilters(makes, tags) {
    if (!makes && !tags) {
      return {};
    }

    const filters = {
      'Publisert': createBooleanFilter('sys.publishedAt[exists]'),
      'Endret': createBooleanFilter('changed'),
      'Navn': createTextFilter('fields.name'),
      'Kodenavn': createTextFilter('fields.slug'),
      'Telefon': createTextFilter('fields.phone'),
      'Tags': createOptionFilter('fields.groupTags', tags.map((tag) => ({id: tag, name: tag}))),
      'Merker': createOptionFilter('fields.makes.sys.id', makes.map((make) => ({id: make.id, name: make.name}))),
      'Nordea lånewidget': createBooleanFilter('fields.nordea'),
      'Ikke bygg sider': createBooleanFilter('fields.skipBuild'),
      'Fritekst søk': createQueryFilter()
    };

    return filters;
  }

  printMakes(dealer) {
    let makeString = '';
    if (dealer.makes) {
      // console.log(dealer.makes);
      makeString += dealer.makes.map((make) => {
        return make.name;
      });
    } else {
      makeString = 'n/a';
    }
    return makeString;
  }

  filterCallback(contentfulFilters = {}) {
    dealers.all(1, ['makes'], contentfulFilters).then((dealers) => {
      this.setState({
        dealers: dealers
      });
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <Loading title="Forhandlerregister" text="Laster forhandlere"/>
      );
    }

    return (
      <section>
        <div className="row">
          <div className="col-sm-12">
            <h1 className="page-header">Forhandlerregister</h1>
            <FilterContainer filters={this.state.filters} availableFilters={this.state.availableFilters} allFiltersCallback={this.filterCallback} />
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th title="Publiseringsstatus"></th>
                    <th>Forhandler</th>
                    <th>Kodenavn</th>
                    <th>Merker</th>
                    <th>Telefon</th>
                    <th>URL</th>
                    <th>Adresse</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.dealers.map((dealer) => {
                    let skipBuild = null;
                    let digitalConsulting = null;
                    if (dealer.skipBuild) {
                      skipBuild = <span className="fa-stack" title="Ikke bygg sider for denne forhandleren">
                        <i className="fa fa-home fa-stack-1x"></i>
                        <i className="fa fa-ban fa-stack-2x text-danger"></i>
                      </span>;
                    }
                    if (dealer.digitalConsultingEnabled) {
                      const platforms = dealer.digitalConsultingPlatforms && Object.values(dealer.digitalConsultingPlatforms).join(', ');
                      if (dealer.digitalConsultingFreetext) {
                        digitalConsulting = <span className="fa-stack" title={`Digital konsultasjon. Fritekst, ${platforms}`}>
                          <i className="fa fa-commenting fa-stack-2x"></i>
                        </span>;
                      } else {
                        digitalConsulting = <span className="fa-stack" title={`Digital konsultasjon. ${platforms}`}>
                          <i className="fa fa-comment fa-stack-2x"></i>
                        </span>;
                      }
                    }

                    return (
                      <PublishStatusTableRow entry={dealer} key={dealer.id}>
                        <td className="text-center">
                          <PublishStatusDot entry={dealer} />
                        </td>
                        <td>
                          <Link to={`/forhandler/${dealer.id}`} key={dealer.id}>{dealer.name}</Link>
                        </td>
                        <td>
                          {dealer.slug}
                        </td>
                        <td>
                          {this.printMakes(dealer)}
                        </td>
                        <td>{dealer.phone}</td>
                        <td><a href={`http://${dealer.websiteUrl}`} target="_new">{dealer.websiteUrl}</a></td>
                        <td>{dealer.address}, {dealer.zipcode} {dealer.ziparea}</td>
                        <td>{skipBuild}{digitalConsulting}</td>
                      </PublishStatusTableRow>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* <h2>Brands</h2>
            <Table objects={this.state.brands}></Table>*/}
          </div>
        </div>
      </section>
    );
  }
}

export default DealerRegisterComponent;
